import { defineAsyncComponent as d, ref as o, computed as x, watchEffect as w, createBlock as y, openBlock as C, unref as S, withCtx as g, createVNode as L, resolveDynamicComponent as V } from "vue";
import { themeProp as P } from "../../../composables/useTheme.js";
const h = "DsSelectBoxSearch", T = "DsSelectBoxDefault", I = /* @__PURE__ */ Object.assign({
  name: "DsFormSelectBox",
  inheritAttrs: !1
}, {
  __name: "form-select-box",
  props: {
    ...P,
    /**
     * Select box field options list
     * Should be an array of objects. Each object need to have mandatory "value", "id", "text" property:
     * [{ id: 'uid', text: 'display text', value: 'value to emit' }]
     */
    options: {
      type: Array,
      required: !0,
      validator: (e) => e === null || e.every((r) => r && r.id !== void 0 && r.value !== void 0 && r.text !== void 0)
    },
    /**
     * Select box field placeholder, will be the first option in the list when there is a value selected
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Select box field value
     */
    value: {
      type: String,
      default: ""
    },
    /**
     * Select box field label text
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Select box search field labels
     */
    labels: {
      type: Object,
      default: () => ({})
    },
    /**
     * Select box field error message
     */
    errorMessage: {
      type: String,
      default: ""
    },
    /**
     * Select box field required
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Select box field search flag
     */
    search: {
      type: Boolean,
      default: !1
    },
    /**
     * Select box field search term max length
     */
    maxLength: {
      type: Number,
      default: 35
    },
    /**
     * Select box field error
     */
    hasError: {
      type: Boolean,
      default: !1
    },
    /**
     * Select box flag, to indicate that multiple options can be selected
     */
    multiple: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["value"],
  setup(e, { emit: r }) {
    const O = d(() => import("../form-field-layout/form-field-layout.vue.js")), b = d(
      () => import("../../select-box/select-box-container/select-box-container.vue.js")
    ), B = d(() => import("../../select-box/select-box-default.vue.js")), D = d(() => import("../../select-box/select-box-search.vue.js")), E = r, t = e, n = o(!!t.value), u = o(!1), i = o(t.hasError), f = o(!1), v = o({}), a = o(""), N = x(() => a.value === h ? D : B), q = x(() => a.value === h && u.value || n.value);
    w(() => {
      n.value = !!t.value, i.value = t.hasError;
    }), t.search ? (a.value = h, f.value = !1) : (a.value = T, f.value = !0);
    function A(l) {
      n.value = !!l, E("value", l), t.required && (i.value = l === "");
    }
    function k(l) {
      l(), u.value = !0;
    }
    function F(l) {
      l(), u.value = !1;
    }
    function M() {
      var l;
      t.required && u.value && !n.value && (i.value = !0), u.value = !1, (l = v.value[a.value]) != null && l.handleClickOutside && v.value[a.value].handleClickOutside();
    }
    return (l, m) => (C(), y(S(O), {
      label: e.label,
      theme: l.theme,
      "is-active": q.value,
      required: e.required,
      "has-error": i.value,
      "error-message": e.errorMessage
    }, {
      default: g((p) => [
        L(S(b), {
          class: "ds-width-full",
          "first-letter-search": f.value,
          onClickOutside: M
        }, {
          default: g((c) => [
            (C(), y(V(N.value), {
              id: p.uid,
              key: p.uid,
              ref: (s) => v.value[`component-${a.value}`] = s,
              theme: l.theme,
              options: e.options,
              labels: e.labels,
              placeholder: e.placeholder,
              "show-placeholder": !1,
              value: e.value,
              multiple: e.multiple,
              "max-length": e.maxLength,
              "focus-index": c.focusIndex,
              opened: c.opened,
              "with-icon": !1,
              onOpen: (s) => k(c.open),
              onClose: (s) => F(c.close),
              onValue: m[0] || (m[0] = (s) => A(s))
            }, null, 40, ["id", "theme", "options", "labels", "placeholder", "value", "multiple", "max-length", "focus-index", "opened", "onOpen", "onClose"]))
          ]),
          _: 2
        }, 1032, ["first-letter-search"])
      ]),
      _: 1
    }, 8, ["label", "theme", "is-active", "required", "has-error", "error-message"]));
  }
});
export {
  I as default
};
